import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useAttachedResourcesStyles = makeStyles(() => ({
  sidebarIcon: {
    width: 16,
    height: 16,
    color: colors.text,
  },
  contentLayout: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    alignItems: 'stretch',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
    },
  },
  mainContent: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
  },
  blockHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    minHeight: 36,
  },
  blockIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.xs,
    borderRadius: radius.sm,
    backgroundColor: colors.iconSurface,
  },
  blockIcon: {
    width: 20,
    height: 20,
    color: colors.text,
  },
  blockTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.text,
    lineHeight: 1,
  },
  resourceBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
  },
  resourceSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    scrollMarginTop: 110,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
  },
  sectionIcon: {
    width: 24,
    height: 24,
    flexShrink: 0,
    objectFit: 'contain',
  },
  sectionTitle: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    letterSpacing: 0.32,
    lineHeight: 1.4,
  },
  resourceGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: spacing.sm,
    alignItems: 'stretch',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(211px, 1fr))',
      gap: spacing.sm,
    },
  },
  resourceGridItem: {
    height: '100%',
    minHeight: 0,
  },
  emptyState: {
    minHeight: 280,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    textAlign: 'center',
    padding: spacing.lg,
  },
  emptyTitle: {
    margin: 0,
    fontFamily: fonts.gothicBold,
    fontSize: 26,
    color: colors.text,
    lineHeight: 1.2,
  },
  emptyText: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.textSecondary,
    lineHeight: 1.4,
  },
  backButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    padding: 0,
    marginBottom: spacing.sm,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 1,
  },
  backIcon: {
    width: 14,
    height: 14,
  },
}));
